import { render } from "./followEdit.vue?vue&type=template&id=1219ba38&scoped=true"
import script from "./followEdit.vue?vue&type=script&lang=js"
export * from "./followEdit.vue?vue&type=script&lang=js"

import "./followEdit.vue?vue&type=style&index=0&id=1219ba38&scoped=true&lang=css"

import exportComponent from "G:\\zhongfu\\web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1219ba38"]])

export default __exports__